module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.vehicleId),
      expression: "trip.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "vehicleId",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.getDeviceName]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_no), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.deviceId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Device")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.deviceId),
      expression: "trip.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isDeviceDisable,
      "required": "",
      "name": "deviceId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Device")]), _vm._v(" "), _vm._l((_vm.device_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "deviceId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Device is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._v("\n                \\\n                "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "journeyManager"
    }
  }, [_vm._v("\n                  Drivers\n                ")]), _vm._v(" "), _c('vue-select', {
    attrs: {
      "label": "drivers",
      "multiple": "",
      "options": this.driver_name,
      "searchable": true,
      "language": "en-US"
    },
    model: {
      value: (_vm.trip.drivers),
      callback: function($$v) {
        _vm.$set(_vm.trip, "drivers", $$v)
      },
      expression: "trip.drivers"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Scheduled Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "scheduleDate",
      "required": "",
      "lang": "en",
      "name": "scheduleDate",
      "not-before": _vm.disabledBefore,
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    model: {
      value: (_vm.trip.scheduleDate),
      callback: function($$v) {
        _vm.$set(_vm.trip, "scheduleDate", $$v)
      },
      expression: "trip.scheduleDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Date is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("Schedule Date is invalid")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', [_vm._v("Scheduled Time")]), _vm._v(" "), _c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduledTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('vue-timepicker', {
    staticStyle: {
      "width": "271px"
    },
    attrs: {
      "name": "scheduledTime",
      "required": ""
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduledTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Schedule Time is a required field\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.locations), function(input, index) {
    return _c('div', {
      key: index,
      staticClass: "input wrapper flex items-center"
    }, [_c('validate', {
      staticClass: "form-group required-field",
      attrs: {
        "auto-label": ""
      }
    }, [_c('label', [_vm._v("Stop " + _vm._s(index + 1))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.locationId),
        expression: "input.locationId"
      }],
      staticClass: "form-control",
      attrs: {
        "required": "",
        "name": "locationsArray"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(input, "locationId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.handleChange($event, index)
        }]
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      }
    }, [_vm._v("Select Location")]), _vm._v(" "), _vm._l((_vm.locationList), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": item._id
        }
      }, [_vm._v("\n                        " + _vm._s(item.siteName) + "\n                      ")])
    })], 2), _vm._v(" "), _c('field-messages', {
      staticClass: "form-control-feedback",
      attrs: {
        "name": "regionManager",
        "show": "$touched || $submitted"
      }
    }, [_c('div', {
      attrs: {
        "slot": "required"
      },
      slot: "required"
    }, [_vm._v("\n                        HCV Operation Manager is a required field\n                      ")])])], 1), _vm._v(" "), _c('svg', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === (_vm.locations.length) - 1),
        expression: "index === (locations.length) -1"
      }],
      staticClass: "ml-2 cursor-pointer",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.addField(input, _vm.locations)
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "green",
        "d": "M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"
      }
    })]), _vm._v(" "), _c('svg', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.locations.length > 2),
        expression: "locations.length > 2"
      }],
      staticClass: "ml-2 cursor-pointer",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "width": "24",
        "height": "24"
      },
      on: {
        "click": function($event) {
          return _vm.removeField(index, _vm.locations)
        }
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "fill": "#EC4899",
        "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z"
      }
    })])], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.regionManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("HCV Operation Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.regionManager),
      expression: "trip.regionManager"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isGAHeadDisable,
      "required": "",
      "name": "regionManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "regionManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select HCV Operation Manager")]), _vm._v(" "), _vm._l((_vm.region_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "regionManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      HCV Operation Manager is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.journeyManager),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Journey Manager")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trip.journeyManager),
      expression: "trip.journeyManager"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isJourenyManagerDisable,
      "required": "",
      "name": "journeyManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.trip, "journeyManager", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Jouney Manager")]), _vm._v(" "), _vm._l((_vm.journey_managers), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.key
      }
    }, [_vm._v("\n                      " + _vm._s(item.value) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "journeyManager",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Journey Manager is a required field\n                    ")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Trip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formstate.$valid
    },
    on: {
      "click": _vm.createTrip
    }
  }, [_vm._v("\n              Add Trip\n            ")])], 1)], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f29b210a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip/TripCreate.vue
// module id = 2023
// module chunks = 1